import { createAsyncTaskQueue } from "../taskQueue";
import { queryExecApiUrlRegex } from "./common";

/**
 * Ensures that only one query exec call can happen at a time.
 */
export function createOneApiCallAtATimeAdapter(defaultAdapter) {
  const [
    queryExecAsyncQueue,
    loginAsyncQueue,
    authAsyncQueue,
    pagesAsyncQueue,
  ] = [
    createAsyncTaskQueue(),
    createAsyncTaskQueue(),
    createAsyncTaskQueue(),
    createAsyncTaskQueue(),
  ];
  return async (config) => {
    const url = getCleanPath(config.url);

    if (queryExecApiUrlRegex.test(url)) {
      return newPromiseForAsyncQueue(queryExecAsyncQueue);
    }
    if (url.endsWith("api/v1/login")) {
      return newPromiseForAsyncQueue(loginAsyncQueue);
    }
    if (url.endsWith("api/v1/auth")) {
      return newPromiseForAsyncQueue(authAsyncQueue);
    }
    if (url.includes("api/v1/pages")) {
      return newPromiseForAsyncQueue(pagesAsyncQueue);
    }
    return defaultAdapter(config);

    function newPromiseForAsyncQueue(queue) {
      return new Promise((resolve, reject) => {
        queue.push(() => {
          return defaultAdapter(config).then(resolve).catch(reject);
        });
      });
    }
  };
}

const queryHashParts = /[#?].*/;

function getCleanPath(url) {
  return String(url).replace(queryHashParts, "");
}

export const exportedForTesting = {
  getCleanPath,
};
